<template>
  <nx-bform-group :label="requiredLabel(name)" v-bind="$attrs">
    <slot>
      <nx-bform-input
        :name="name"
        :rules="{ required,regex: /^[a-zA-Z- ]+$/  }"
        :value="$attrs.value"
        @input="$listeners.input"
      />
    </slot>
  </nx-bform-group>
</template>

<script>
import FormGroupMixin from "../form-group.mixin";

export default {
  mixins: [FormGroupMixin],
  computed: {
    name() {
      return this.label || this.$t("surname");
    }
  }
};
</script>

<i18n src="@/locales/registration.locale.json" />
